module.exports = __webpack_public_path__ + "static/media/minus_circle_red.0bf27324.svg";